import type { ReactNode } from 'react';

/**
 * Form-field primitive used throughout the panel: a small uppercase label,
 * optional one-line hint underneath, then the children (input, textarea,
 * editor, whatever). Same shape as the prototype's Field wrapper.
 *
 * Pure visual; no behaviour.
 */
export function Field({
  label,
  hint,
  children,
}: {
  label: string;
  hint?: string;
  children: ReactNode;
}) {
  return (
    <div>
      <label className="text-xs uppercase tracking-widest block mb-1 text-ink-2">
        {label}
      </label>
      {hint && <div className="text-xs mb-2 text-ink-3">{hint}</div>}
      {children}
    </div>
  );
}
